import React, { useEffect, useState } from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import { PriceRange } from 'types/event/eventStep3'
import { LeagueFinalResp } from 'types/league/league'
import EstimatedActivitySummary from './EstimatedActivitySummary'
import AdditionalFee from './AdditionalFee'

interface EstimatedSummaryProps {
  data: LeagueFinalResp
  numberOfStaff: number
  estimatedSalary: PriceRange
}

const Summary: React.FC<EstimatedSummaryProps> = ({
  data,
  numberOfStaff,
  estimatedSalary,
}) => {
  const { estimateCostPayload, setEstimateCostPayload } = leagueEventStore(
    store => ({
      estimateCostPayload: store.estimateCostPayload,
      setEstimateCostPayload: store.setEstimateCostPayload,
    }),
  )
  const [estimatedVenuePrice, setEstimatedVenuePrice] = useState<
    number | PriceRange
  >(0)

  useEffect(() => {
    if (data?.venue) {
      const price = data.venue?.price
      // `!== undefined || !== null` was always true, so a venue without a fixed
      // price (price-range or to-be-determined) set estimatedVenuePrice to undefined
      // and the render crashed on `.min`. Use `&&`, and fall back to the price range
      // (guarded) so the value is always a number or a {min,max} object.
      if (price !== undefined && price !== null) {
        setEstimatedVenuePrice(price)
        setEstimateCostPayload({ venuePrice: price })
      } else {
        const venuePrice = {
          min: data.venue?.priceRange?.min ?? 0,
          max: data.venue?.priceRange?.max ?? 0,
        }
        setEstimatedVenuePrice(venuePrice)
        setEstimateCostPayload({ venuePrice })
      }
    } else {
      setEstimatedVenuePrice(0)
      setEstimateCostPayload({ venuePrice: 0 })
    }
  }, [data])

  return (
    <>
      <h3 className="text-13 w-600">Estimated Summary</h3>
      <div className="mt-20px">
        <div className=" flex align-center justify-between gap-20px mt-10px">
          <p>Staff (x{numberOfStaff})</p>
          <p>{`$${(estimatedSalary.min * numberOfStaff).toFixed(2)} ~ $${(
            estimatedSalary.max * numberOfStaff
          ).toFixed(2)}`}</p>
        </div>

        <div className=" flex align-center justify-between gap-20px mt-10px">
          <p>Venue</p>

          {typeof estimatedVenuePrice === 'number'
            ? `$${estimatedVenuePrice.toFixed(2)}`
            : `$${estimatedVenuePrice.min.toFixed(
                2,
              )} ~ $${estimatedVenuePrice.max.toFixed(2)}`}
        </div>
        <EstimatedActivitySummary data={data} />
      </div>

      <div className="mt-25px">
        <AdditionalFee />
      </div>

      <div className="flex align-center justify-between mt-25px">
        <h3 className="text-15 w-600">Estimated Total</h3>
        {/* <h3 className="text-15 w-600">$730.00 - $840.00</h3> */}
        <h3 className="text-15 w-600">{`$${estimateCostPayload.estimatedTotalPrice.min.toFixed(
          2,
        )} - $${estimateCostPayload.estimatedTotalPrice.max.toFixed(2)}`}</h3>
      </div>
    </>
  )
}

export default Summary
